import axios from 'axios';
import type { AuthenticatingRestApi } from '@idem/tipos/authenticating-rest-api';

import { API_URL } from '@idem/common/constantes';

export class CookieRestClient implements AuthenticatingRestApi {
  login(): Promise<any> {
    throw new Error('Método no implementado');
  }

  logout(): void {
    throw new Error('Método no implementado');
  }

  get(uri: string): Promise<any> {
    return axios.get(`${API_URL}/${uri}`, { withCredentials: true }).then(res => res.data);
  }

  post(uri: string, data: object, options?: any): Promise<any> {
    return axios
      .post(`${API_URL}/${uri}`, data, { ...options, withCredentials: true })
      .then(res => res.data);
  }

  put(uri: string, data: object): Promise<any> {
    return axios.put(`${API_URL}/${uri}`, data, { withCredentials: true }).then(res => res.data);
  }

  delete(uri: string): Promise<any> {
    return axios.delete(`${API_URL}/${uri}`, { withCredentials: true }).then(res => res.data);
  }
}
